import type { CitedProductList } from '@atlassian/conversation-assistant-instrumentation/types/analytics';
import { type Sources } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { extractProductNameFromARI } from '../../common/utils/ari';

export const constructCitedProductList = (sources: Sources | undefined): CitedProductList => {
	if (!sources) {
		return {};
	}

	const citedProductList: CitedProductList = {};
	sources.forEach((source) => {
		const productName = extractProductNameFromARI(source.ari);
		if (productName) {
			citedProductList[productName] = (citedProductList[productName] ?? 0) + 1;
		}
	});

	return citedProductList;
};
